import React from 'react';
import { Link } from 'react-router-dom';
import logoPrimary from '../../assets/logos/logo-primary.png';

const AuthCardLeft = () =>{
  return (
    <div className="auth-card-left">
      <div className="text-center">
        <Link to="/">
          <img src={logoPrimary} alt="Revealer Logo" style={{ width: '150px', marginBottom: '1rem' }} />
        </Link>
        <p>Unlock Creative Momentum</p>
      </div>
    </div>
  );
};

export default AuthCardLeft;